const GalleryArt = (() => {
  const ns='http://www.w3.org/2000/svg';
  function el(name,attrs){const node=document.createElementNS(ns,name);for(const [key,value] of Object.entries(attrs))node.setAttribute(key,value);return node;}
  function create(product){
    const d=product.presentation;
    const svg=el('svg',{class:'gallery-artwork',style:`--art-ratio:${d.width}/${d.height}`,viewBox:`0 0 ${d.width} ${d.height}`,role:'img','aria-label':product.name});
    for(const panel of d.panels){
      const viewport=el('svg',{x:panel.x,y:0,width:panel.w,height:d.height,viewBox:panel.crop.join(' '),style:'overflow:hidden'});
      viewport.append(el('image',{href:panel.src,width:panel.width,height:panel.height}));svg.append(viewport);
    }
    return svg;
  }
  return {create};
})();
